<template>
  <div id="foot-fixed" :style="{height:name.height}">
    <footer class="foot-bottom">
      <div v-for="item in bottomNav" :class="{'active': name.name == item.text}" :key="item.text" @click="link(item.path)">
        <i></i>
        <p>{{item.text}}</p>
      </div>
    </footer>
  </div>
</template>
<script>
  export default {
    props: ['name'],
    data() {
      return {
        bottomNav: [{
            path: "/",
            text: "首页"
          },
          {
            path: "/activity/list",
            text: "活动"
          },
          {
            path: "/shop/list",
            text: "战疫产品"
          },
          {
            path: "/mine",
            text: "我的"
          }
        ],
        path: this.$route.path
      };
    },
    methods: {
      link: function (path) {
        this.$router.push({
          path: path
        });
      }
    }
  };

</script>
<style lang='less' scoped>
  

  #foot-fixed {
    width: 100%;
    height: 99/@rem-size;
    background-color: #fff;
    font-size: 20/@rem-size;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    box-shadow: 0 0 18px 0 rgba(208, 208, 208, 0.2);
    z-index: 101;
  }

  .foot-bottom {
    width: 100%;
    height: 99/@rem-size;
    background-color: #fff;
    font-size: 20/@rem-size;
    display: flex;

    div {
      flex: 1;
      text-align: center;
      padding-top: 5/@rem-size;
      color: #999999;

      i {
        display: inline-block;
        width: 50/@rem-size;
        height: 50/@rem-size;
        background-image: url("../assets/images/nav.png");
        background-repeat: no-repeat;
        background-size: 200/@rem-size 100/@rem-size;
      }

      &:nth-of-type(1) i {
        background-position: 0 -50/@rem-size;
      }

      &:nth-of-type(2) i {
        background-position: -50/@rem-size -50/@rem-size;
      }

      &:nth-of-type(3) i {
        background-position: -100/@rem-size -50/@rem-size;
      }

      &:nth-of-type(4) i {
        background-position: -150/@rem-size -50/@rem-size;
      }
    }

    .active {
      color: #005fd5;

      &:nth-of-type(1) i {
        background-position: 0 0;
      }

      &:nth-of-type(2) i {
        background-position: -50/@rem-size 0;
      }

      &:nth-of-type(3) i {
        background-position: -100/@rem-size 0;
      }

      &:nth-of-type(4) i {
        background-position: -150/@rem-size 0;
      }
    }
  }

</style>
